import * as React from "react";
import { Button } from "semantic-ui-react";
import { useDispatch } from "@teamprevent/employee-redux";

import { toast } from "@teamprevent/common/toasts";

import { resendCompletionRequest } from "../actions";

export const ResendCompletionRequestButton:
    React.FunctionComponent<{ sraManagerSectionId: string }> = (props) => {
        const [clicked, setClicked] = React.useState(false);
        const dispatch = useDispatch();

        const onClick = async () => {
            setClicked(true);
            dispatch(resendCompletionRequest(props.sraManagerSectionId));
            toast.success("Email has been sent.");
        };

        return (
            <Button disabled={clicked} content="Resend Request" onClick={onClick} />
        );
    };
